import { httpCreate } from './http';

const http = httpCreate('/srv/api/fileStorage');

export const fileStorage = {
	// 获取上传token
	uploadToken(params) {
		return http.get('/uploadToken/0', {
			params,
		});
	},
};
